import { useEffect, useState } from "react";
import api from "@/lib/api";
import logger from "@/lib/logger";

/* Polls /api/admin/onboarding-queue every 30s and returns the count of parties
 * waiting on admin review (status='submitted'). Returns 0 for users without
 * the approvals_admin feature grant, or on any network blip. */
export default function usePendingApprovals(user) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user || !user.permissions?.approvals_admin) {
      setCount(0);
      return;
    }
    let cancelled = false;
    const fetchCount = async () => {
      try {
        const { data } = await api.get("/admin/onboarding-queue");
        if (!cancelled) setCount(data.submitted_count || 0);
      } catch (e) { logger.debug("approvals badge fetch failed", e?.message || e); }
    };
    fetchCount();
    const id = setInterval(fetchCount, 30000);
    return () => { cancelled = true; clearInterval(id); };
  }, [user]);

  return count;
}
